<template>
	<v-container fluid grid-list-md class="pa-0">
		<Loading v-if="loading" />
		<form v-else >
			<NewProductStepItemType :form="form" />

			<FarmeDivider />

			<NewProductStepItemGeneralData
				:form="form"
				:productGroups="productGroups"
				:associatedConditions="associateConditions"
				:storageConditions="storageConditions"
				:umbrellaItems="umbrellaItems"
				@reloadAssociatedConditions="getAssociateConditions()"/>

			<FarmeDivider />

			<h3 class="my-3">Fabricante</h3>
			<v-layout wrap>
				<v-flex xs12>
					<v-autocomplete
						v-model="form.manufacturer"
						background-color="white"
						:prepend-inner-icon="manufacturers.loading ? 'sync' : 'search'"
						:items="manufacturers.items"
						box
						label="Fabricante"
						clearable
						:loading="manufacturers.loading"
						:disabled="manufacturers.loading"
						item-text="name"
						return-object
						data-vv-name="Fabricante"
						v-validate="{ required: true }"
						append-outer-icon="add"
						@click:append-outer="createManufacturer = true"
						:error-messages="errors.collect('Fabricante')"/>
				</v-flex>
			</v-layout>

			<FarmeDivider />

			<NewProductStepItemMeasurement
				:form="form"
				:unitsOfMeasurement="unitsOfMeasure"/>
		</form>

		<v-dialog
			v-model="createManufacturer"
			persistent
			scrollable
			transition="fade"
			max-width="840px">
			<transition>
				<DialogCreateManufacturer
					v-if="createManufacturer"
					@close="closeManufacturerDialog()"/>
			</transition>
		</v-dialog>
	</v-container>
</template>

<script>
import { AssociatedConditionPresenter } from '@Presenter/associated-condition-presenter';
import { ProductGroupPresenter } from '@Presenter/product-group-presenter';
import { UnitOfMeasurePresenter } from '@Presenter/unit-of-measure-presenter';
import { ManufacturerPresenter } from '@Presenter/manufacturer-presenter';
import { UmbrellaItemPresenter } from '@Presenter/umbrella-item-presenter';
import FarmeDivider from '@Componentes/farme-divider.vue';
import DialogCreateManufacturer from '../../../dialog-new-manufacturer.vue';
import NewProductStepItemType from './item-type.vue';
import NewProductStepItemMeasurement from './measurements.vue';
import NewProductStepItemGeneralData from './general-data.vue';
import Loading from '../../loading.vue';

export default {
	name: 'NewProductStepItem',
	$_veeValidate: { validator: 'new' },
	components: {
		DialogCreateManufacturer,
		NewProductStepItemType,
		NewProductStepItemMeasurement,
		NewProductStepItemGeneralData,
		FarmeDivider,
		Loading
	},
	props: {
		form: {
			required: true,
			type: Object
		}
	},
	async created() {
		try {
			await Promise.all([
				// this.getAssociateConditions(),
				this.getProductGroups(),
				this.getUnitsOfMeasure(),
				this.getManufacturers()
				// this.getUmbrellaItems()
			]);
			this.loading = false;
		} catch (error) {
			this.$store.dispatch('SHOW_SNACKBAR', {
				message: 'Erro ao carregar dados do formulário',
				color: 'error'
			});
		}
	},
	data() {
		return {
			loading: true,
			manufacturers: {
				loading: false,
				items: []
			},
			associateConditions: [],
			productGroups: [],
			unitsOfMeasure: [],
			umbrellaItems: [],
			createManufacturer: false
		};
	},
	computed: {
		storageConditions() {
			return [
				'Temperatura ambiente (não requer refrigeração)',
				'Refrigerado',
				'Congelado (freezer)',
				'Refrigerar após aberto',
				'Congelar após aberto'
			];
		}
	},
	methods: {
		async getAssociateConditions() {
			const associatedConditionsResponse = await AssociatedConditionPresenter.findAll();
			this.associateConditions = associatedConditionsResponse.items;
		},
		async getProductGroups() {
			const productGroupsReseponse = await ProductGroupPresenter.findAll();
			this.productGroups = productGroupsReseponse.items;
		},
		async getUnitsOfMeasure() {
			const unitsOfMeasureResponse = await UnitOfMeasurePresenter.findAll();
			this.unitsOfMeasure = unitsOfMeasureResponse.items;
		},
		async getManufacturers() {
			this.manufacturers.loading = true;
			const manufacturersResponse = await ManufacturerPresenter.findAll();
			this.manufacturers.items = manufacturersResponse.items;
			this.manufacturers.loading = false;
		},
		async getUmbrellaItems() {
			const umbrellaItemsResponse = await UmbrellaItemPresenter.findAll();
			this.umbrellaItems = umbrellaItemsResponse.items;
		},
		async closeManufacturerDialog() {
			await this.getManufacturers();
			this.createManufacturer = false;
		},
		async validate() {
			return Boolean(await this.$validator.validateAll());
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
